import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideCalAngular } from '@cvx/cal-angular';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { authInterceptor } from './auth/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideCalAngular({
      autoSignIn: true,
      popupForLogin: false,
      cacheLocation: 'localStorage',
      instance: 'https://login.microsoftonline.com/',
      tenantId: environment.tenantId,
      clientId: environment.clientId,
      redirectUri: window.location.origin,
      oidcScopes: ['openid', 'profile', 'User.Read', 'offline_access'],
      graphScopes: ['User.Read', 'User.Read.All'],
    }),
  ]
};
